import { Routes } from "@angular/router";
import { ProductsComponent } from "./products/products.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { NavDividendsComponent } from "./nav-dividends/nav-dividends.component";
import { KnowledgeCenterComponent } from "./knowledge-center/knowledge-center.component";
import { DownloadsComponent } from "./downloads/downloads.component";
import { CareersComponent } from "./careers/careers.component";
import { DisclaimerComponent } from "./key-policies/disclaimer/disclaimer.component";
import { RiskFactorsComponent } from "./key-policies/risk-factors/risk-factors.component";
import { StatuoryComponent } from "./key-policies/statuory/statuory.component";
import { PrivacyPolicyComponent } from "./key-policies/privacy-policy/privacy-policy.component";
import { CookiePolicyComponent } from "./key-policies/cookie-policy/cookie-policy.component";
import { TermsUseComponent } from "./key-policies/terms-use/terms-use.component";
import { BranchesComponent } from "./branches/branches.component";
import { WriteUsMobileComponent } from "./pop-ups/write-us-mobile/write-us-mobile.component";
import { CallBackMobileComponent } from "./pop-ups/call-back-mobile/call-back-mobile.component";
import { LocateUsMobileComponent } from "./pop-ups/locate-us-mobile/locate-us-mobile.component";
import { NfoComponent } from "./nfo/nfo.component";
import { CeoDeskComponent } from "@root/components/ceo-desk/ceo-desk.component";
import { ArticleDetailsComponent } from "@component/ceo-desk/articles/article-details.component";
import { LatestNewsComponent } from "./latest-news/latest-news.component";
import { MediaComponent } from "./media/media.component";
import { ExecutiveRemunerationComponent } from "./key-policies/statuory/executive-remuneration/executive-remuneration.component";
import { InterviewsComponent } from "@component/ceo-desk/interviews/interviews.component";
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { CeoLibraryComponent } from '@component/ceo-desk/ceo-library/ceo-library.component';
const ɵ0 = () => import("./home/home.module.ngfactory").then((m) => m.HomeModuleNgFactory), ɵ1 = {
    breadCrumb: "Products",
    url: "products",
    headerImgPath: "assets/images/banner_products.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Mutual Funds India - Types & Benefits of Mutual Funds Investment | ITI MF",
    meta: "Explore the different types of mutual fund products offered by ITI Mutual Fund. ITI Mutual Fund provides different types of mutual funds, mutual fund calculators, guide to mutual funds, sip investment, tax saving elss mutual funds, etc. Learn about the mutual funds risk, performance & NAVs.",
    keywords: "Best Investment Plan,ULIP,Best ULIP Funds,Best SIP Plans,SIP Calculator,Systematic Investment Plan,SIP,Mutual Fund Calculator,Mutual Funds,Save Tax"
}, ɵ2 = () => import("./product-details/product-details.module.ngfactory").then((m) => m.ProductDetailsModuleNgFactory), ɵ3 = {
    breadCrumb: "Products",
    url: "products",
    headerImgPath: "assets/images/banner_product_small.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false
}, ɵ4 = () => import("./distributor/distributor.module.ngfactory").then((m) => m.DistributorModuleNgFactory), ɵ5 = {
    breadCrumb: "Distributors",
    url: "distributor",
    headerImgPath: "assets/images/banner_distributor.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Partner with ITI Mutual Fund - Mutual Fund Distributor  | ITI Mutual Fund",
    meta: "ITI Mutual Fund is promoted by The Investment Trust of India Group which has close to 190 offices and over 3000 employees with a presence in all major cities across India.",
}, ɵ6 = {
    breadCrumb: "Contact Us",
    url: "contact",
    headerImgPath: "assets/images/banner_contact.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Contact Us - ITI Mutual Fund",
    meta: "For any fund related queries get in touch with ITI Mutual Fund Customer Care Toll-free Number : 1800-266-9603. Board Line Number : +91 022 69153500.",
}, ɵ7 = () => import("./about-us/about-us.module.ngfactory").then((m) => m.AboutUsModuleNgFactory), ɵ8 = {
    breadCrumb: "About Us",
    url: "about",
    headerImgPath: "assets/images/banner_about.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "About Us - ITI Mutual Fund",
    meta: "For millions of Indians who aspire to a better financial status, we are here to help. Welcome to a mutual fund company where thoughtful and investor centric investment solutions are offered along with robust invest management and research expertise.",
}, ɵ9 = {
    breadCrumb: "NAV & IDCW",
    url: "nav-dividends",
    headerImgPath: "assets/images/banners_nav&div.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Latest NAV & IDCW of all ITI Mutual fund schemes | ITI MF",
    meta: "Check latest & historical NAV and IDCW of all ITI Mutual Fund schemes offered by ITI Investment Management here. Explore all latest NAVs or Net Asset Value, dividends & past performances for all mutual funds schemes.",
    keywords: "ITI Equity Fund, ITI Focused Equity Fund, ITI Large Cap Fund, ITI Value Fund, ITI Dynamic Bond Fund, ITI Large and MidCap Fund, ITI Midcap Fund, ITI Tax Advantage Fund, NAV, IDCW"
}, ɵ10 = {
    breadCrumb: "Knowledge Center",
    url: "knowledge",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Knowledge Center - ITI Mutual Fund",
    meta: "ITI AMC Knowledge Center is a mutual fund guide which aims at providing information right from the  basics to the latest updates of mutual funds. At ITI Mutual Fund we strongly believe that an educated investor is an empowered investor"
}, ɵ11 = {
    breadCrumb: "Downloads",
    url: "downloads",
    headerImgPath: "assets/images/banners_download.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Downloads - ITI Mutual Fund",
    meta: "Find more information on KYC Non-Individual Form and MF Utility Forms.",
}, ɵ12 = {
    breadCrumb: "Careers",
    url: "careers",
    headerImgPath: "assets/images/banner_career.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Careers - ITI Mutual Fund",
    meta: "In a dynamic and fast-growing economy, mutual funds have opened the door to new, modern and attractive investing opportunities.",
}, ɵ13 = () => import("./investors/investor.module.ngfactory").then((m) => m.InvestorModuleNgFactory), ɵ14 = {
    breadCrumb: "For Investors",
    url: "investors",
    headerImgPath: "assets/images/banner_investor.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Investor Education - A Complete Guide on Mutual Fund | ITI Mutual Fund",
    meta: "Mutual Fund Investment Guide: ITI AMC presents Investor Education Guide for investors to understand mutual funds and make the right investing decisions. Investor Education Awareness Programs by ITI Mutual Fund to help investors make right investing decisions."
}, ɵ15 = () => import("./faq/faq.module.ngfactory").then((m) => m.FaqModuleNgFactory), ɵ16 = {
    breadCrumb: "FAQs",
    url: "faq",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ17 = {
    breadCrumb: "Risk Factors",
    url: "risk-factor",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Risk Factors - ITI Mutual Fund",
    meta: "Risk Factors · Mutual fund investments are subject to market risks, read all scheme related documents carefully. Mutual Funds and securities investments are subject to market risks and there is no assurance or guarantee that the Fund's objective will be achieved."
}, ɵ18 = {
    breadCrumb: "Statutory Disclosure",
    url: "statuory-disclosure",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ19 = {
    breadCrumb: "Executive Remuneration",
    url: "executive-remuneration",
    headerImgPath: "assets/images/executive_remuneration_banner.png",
    title: "Statutory Disclosures - ITI Mutual Fund",
    meta: "Here's the list of statutory disclosures and ITI mutual fund investment policies by ITI Mutual Fund. Know more!",
}, ɵ20 = {
    breadCrumb: " Disclaimer",
    url: "disclaimer",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Disclaimer - ITI Mutual Fund",
    meta: "Disclaimer: ITI Mutual fund investments are subject to market risks. Please read the scheme information and other related documents before investing.",
}, ɵ21 = {
    breadCrumb: " Privacy Policy",
    url: "privacy-policy",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Privacy Policy - ITI Mutual Fund",
    meta: "We, at ITI Mutual Fund, respect investors right to privacy. We recognise that the lawful and correct treatment of personal data is very important to maintain investor's confidence in ourselves.",
}, ɵ22 = {
    breadCrumb: " Cookie Policy",
    url: "cookie-policy",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Cookie Policy - ITI Mutual Fund",
    meta: "ITI cookie policy outlines how we use cookies and how to manage and delete them.",
}, ɵ23 = {
    breadCrumb: " Terms of Use Policy",
    url: "terms-of-use",
    headerImgPath: "assets/images/banner_knowledge.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Cookie Policy - ITI Mutual Fund",
    meta: "ITI cookie policy outlines how we use cookies and how to manage and delete them.",
}, ɵ24 = {
    breadCrumb: " KFintech Branches",
    url: "karvy-branches",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "KFinTech Branches - ITI Mutual Fund",
    meta: "Branch offices of KFin Technologies Limited",
}, ɵ25 = {
    breadCrumb: " ITI AMC Branches",
    url: "amc-branches",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "ITI AMC Branches - ITI Mutual Fund",
    meta: "Reach out to our wide network of branches, distributors and agents, to invest in mutual funds - ITI AMC"
}, ɵ26 = {
    breadCrumb: "Locate your Advisor",
    url: "locate-advisor",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
    title: "Locate your Advisor - ITI Mutual Fund",
    meta: ""
}, ɵ27 = {
    breadCrumb: " Write to us",
    url: "write-to-us",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: true,
    hasCta: false,
    hasCarousel: false,
    title: "Write Us - ITI Mutual Fund",
    meta: ""
}, ɵ28 = {
    breadCrumb: "Call Back",
    url: "call-back",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: true,
    hasCta: false,
    hasCarousel: false,
}, ɵ29 = {
    breadCrumb: "Locate us",
    url: "locate-us",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: true,
    hasCta: false,
    hasCarousel: false,
}, ɵ30 = {
    breadCrumb: "NFO",
    url: "nfo",
    headerImgPath: "",
    skipBreadCrumb: true,
    hasCta: false,
    hasCarousel: true,
    title: "NFO - ITI Mutual Fund",
    meta: ""
}, ɵ31 = {
    breadCrumb: "CIO's Desk",
    url: "cio-desk",
    headerImgPath: "",
    skipBreadCrumb: true,
    hasCta: false,
    hasCarousel: true,
    title: "From CIO's Desk - ITI Mutual Fund",
    meta: "Check what ITI Mutual Fund CEO Mr. George Joseph has to share with mutual fund investors right here. Visit us and start your investing in Mutual Funds."
}, ɵ32 = {
    breadCrumb: "CIO's Desk",
    url: "cio-desk",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ33 = {
    breadCrumb: "CEO's Library",
    url: "cio-desk/library",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ34 = {
    breadCrumb: "CEO-Interview",
    url: "cio-desk/interview",
    headerImgPath: "assets/images/banner_branch.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ35 = {
    breadCrumb: "Latest News",
    url: "latest-news",
    headerImgPath: "assets/images/latest_news_banner.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ36 = {
    breadCrumb: "Media",
    url: "media",
    headerImgPath: "assets/images/media_banner.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
}, ɵ37 = {
    breadCrumb: "Advertisement",
    url: "advertisement",
    headerImgPath: "assets/images/media_banner.png",
    skipBreadCrumb: false,
    hasCta: false,
    hasCarousel: false,
};
const routes = [
    {
        path: "",
        loadChildren: ɵ0,
    },
    {
        path: "products",
        component: ProductsComponent,
        data: ɵ1,
    },
    {
        path: "products/:id",
        loadChildren: ɵ2,
        data: ɵ3,
    },
    {
        path: "distributor",
        loadChildren: ɵ4,
        data: ɵ5,
    },
    {
        path: "contact",
        component: ContactUsComponent,
        data: ɵ6,
    },
    {
        path: "about",
        loadChildren: ɵ7,
        data: ɵ8,
    },
    {
        path: "nav-dividends",
        component: NavDividendsComponent,
        data: ɵ9,
    },
    {
        path: "knowledge",
        component: KnowledgeCenterComponent,
        data: ɵ10,
    },
    {
        path: "downloads",
        component: DownloadsComponent,
        data: ɵ11,
    },
    {
        path: "careers",
        component: CareersComponent,
        data: ɵ12,
    },
    {
        path: "investors",
        loadChildren: ɵ13,
        data: ɵ14,
    },
    {
        path: "faq",
        loadChildren: ɵ15,
        data: ɵ16,
    },
    {
        path: "risk-factor",
        component: RiskFactorsComponent,
        data: ɵ17,
    },
    {
        path: "statuory-disclosure",
        component: StatuoryComponent,
        data: ɵ18,
    },
    {
        path: "executive-remuneration",
        component: ExecutiveRemunerationComponent,
        data: ɵ19,
    },
    {
        path: "disclaimer",
        component: DisclaimerComponent,
        data: ɵ20,
    },
    {
        path: "privacy-policy",
        component: PrivacyPolicyComponent,
        data: ɵ21,
    },
    {
        path: "cookie-policy",
        component: CookiePolicyComponent,
        data: ɵ22,
    },
    {
        path: "terms-of-use",
        component: TermsUseComponent,
        data: ɵ23,
    },
    {
        path: "karvy-branches",
        component: BranchesComponent,
        data: ɵ24,
    },
    {
        path: "amc-branches",
        component: BranchesComponent,
        data: ɵ25,
    },
    {
        path: "locate-advisor",
        component: BranchesComponent,
        data: ɵ26,
    },
    {
        path: "write-to-us",
        component: WriteUsMobileComponent,
        data: ɵ27,
    },
    {
        path: "call-back",
        component: CallBackMobileComponent,
        data: ɵ28,
    },
    {
        path: "locate-us",
        component: LocateUsMobileComponent,
        data: ɵ29,
    },
    {
        path: "nfo",
        component: NfoComponent,
        data: ɵ30,
    },
    {
        path: "cio-desk",
        component: CeoDeskComponent,
        data: ɵ31,
    },
    {
        path: "cio-desk/articles",
        component: ArticleDetailsComponent,
        data: ɵ32,
    },
    {
        path: "cio-desk/library",
        component: CeoLibraryComponent,
        data: ɵ33,
    },
    {
        path: "cio-desk/interview",
        component: InterviewsComponent,
        data: ɵ34,
    },
    {
        path: "latest-news",
        component: LatestNewsComponent,
        data: ɵ35,
    },
    {
        path: "media",
        component: MediaComponent,
        data: ɵ36,
    },
    {
        path: "advertisement",
        component: AdvertisementComponent,
        data: ɵ37,
    },
];
export class ComponentRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37 };
